import { getErrorMes } from "../admin/api_admin";
import { 
    SuMenuItem, 
    SuAPIError,
    SuCostsResponse,
    SuCompanyInfo,
    SuErrorInfo,
    SuStatisticsInfo,
    SuStatisticsResponse, 
} from "./models_superuser";

const getSuErrorMes = getErrorMes

export const getSuperuserMenuList = async (): Promise<SuMenuItem[] | SuAPIError> => {
    const response = await fetch(`/api/superuser`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getSuErrorMes(response)}
}

export const getSuCompanies = async (company_cd?: number): Promise<SuCompanyInfo[] | SuAPIError> => {
    const params = new URLSearchParams();

    if (company_cd !== undefined) params.append('company_cd', String(company_cd));
    
    const queryString = params.toString();
    const url = `/api/superuser/companies${queryString ? `?${queryString}` : ''}`;
    
    const response = await fetch(url, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getSuErrorMes(response)}
}

export const getSuCosts = async (year?: number, month?: number, company_cd?: number): Promise<SuCostsResponse[] | SuAPIError> => {
    const params = new URLSearchParams();
    
    if (year !== undefined) params.append('year', String(year));
    if (month !== undefined) params.append('month', String(month));
    if (company_cd !== undefined) params.append('company_cd', String(company_cd));
    
    const queryString = params.toString();
    const url = `/api/superuser/costs${queryString ? `?${queryString}` : ''}`;
    
    const response = await fetch(url, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getSuErrorMes(response)}
}

const downloadAttachedData = async (response: Response) => {
    if (response.ok) {
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        
        // Content-Dispositionヘッダーからファイル名を取得
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = `download`;
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)/);
            if (filenameMatch) {
                filename = decodeURIComponent(filenameMatch[1]);
            }
        }
        
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
        return true;
    }
    return false
}

export const downloadSuCosts = async (year?: number, month?: number): Promise<void | SuAPIError> => {
    const params = new URLSearchParams();
    
    if (year !== undefined) params.append('year', String(year));
    if (month !== undefined) params.append('month', String(month));
    
    const queryString = params.toString();
    const url = `/api/superuser/export_costs${queryString ? `?${queryString}` : ''}`;
    
    const response = await fetch(url, {
        method: "GET",
    })
    const success = await downloadAttachedData(response)
    if(success) return;
    return {error: await getSuErrorMes(response)}
}

export const downloadSuErrors = async (datetime_from?: string, datetime_to?: string): Promise<void | SuAPIError> => {
    const params = new URLSearchParams();
    
    if (datetime_from) params.append('datetime_from', datetime_from);
    if (datetime_to) params.append('datetime_to', datetime_to);
    
    const queryString = params.toString();
    const url = `/api/superuser/export_errors${queryString ? `?${queryString}` : ''}`;
    
    const response = await fetch(url, {
        method: "GET",
    })
    const success = await downloadAttachedData(response)
    if(success) return;
    return {error: await getSuErrorMes(response)}
}

export const downloadSuStatistics = async (year: number, month: number, company_cd?: number): Promise<void | SuAPIError> => {
    const params = new URLSearchParams();
    
    params.append('year', String(year));
    params.append('month', String(month));
    if (company_cd !== undefined) params.append('company_cd', String(company_cd));
    
    const queryString = params.toString();
    const url = `/api/superuser/export_statistics${queryString ? `?${queryString}` : ''}`;
    
    const response = await fetch(url, {
        method: "GET",
    })
    const success = await downloadAttachedData(response)
    if(success) return;
    return {error: await getSuErrorMes(response)}
}

export const getSuErrors = async (datetime_from?: string, datetime_to?: string): Promise<SuErrorInfo[] | SuAPIError> => {
    const params = new URLSearchParams();
    
    if (datetime_from) params.append('datetime_from', datetime_from);
    if (datetime_to) params.append('datetime_to', datetime_to);
    
    const queryString = params.toString();
    const url = `/api/superuser/errors${queryString ? `?${queryString}` : ''}`;

    const response = await fetch(url, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getSuErrorMes(response)}
}

export const getSuStatistics = async (year: number, month: number, company_cd?: number): Promise<SuStatisticsResponse | SuAPIError> => {
    const params = new URLSearchParams();
    
    params.append('year', String(year));
    params.append('month', String(month));
    if (company_cd !== undefined) params.append('company_cd', String(company_cd));
    
    const queryString = params.toString();
    const url = `/api/superuser/statistics${queryString ? `?${queryString}` : ''}`;
    
    const response = await fetch(url, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getSuErrorMes(response)}
}